import { GridSkeleton } from "@/components/Skeletons";

export default function NetPresentValueSkeleton() {
  return <GridSkeleton columns={12} rows={14} />;
}
